import { Link, Outlet } from "react-router-dom";
import "../../styles/admin.css";
import { useSnackbarContext } from "../../utils/snackbar/SnackbarContext";
// import { appConstants } from "../../utils/appConstants";

const DefaultLayout = () => {
  const { showSnackbar } = useSnackbarContext();

  const hatenaClick = () => {
    showSnackbar("info", "ヘルプを表示します（モック）");
  };

  const bellClick = () => {
    showSnackbar("info", "通知を表示します（モック）");
  };

  const userSettingClick = () => {
    showSnackbar("info", "設定を表示します（モック）");
  };

  return (
    <>
      <header className="siteHeader">
        <div className="logo">
          <Link to={"/"}>
            <img src="/images/logo.png" alt="logo" />
          </Link>
          for admin
        </div>
        <nav className="headerNav">
          <ul>
            <li>
              <a onClick={hatenaClick}>
                <img src="/images/icon/hatena.svg" alt="icon"/>
              </a>
            </li>
            <li>
              <a onClick={bellClick}>
                <img src="/images/icon/bell.svg" alt="icon"/>
              </a>
            </li>
            <li>
              <a onClick={userSettingClick}>
                <img src="/images/icon/haguruma.svg" alt="icon"/>
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <div className="layout">
        <div className="layoutLeft">
          <input id="leftNavButton" className="leftNavButton" type="checkbox" />
          <label className="leftNavToggle" htmlFor="leftNavButton"></label>
          <nav className="leftNav">
            <h4>
              こんにちは smaresバーガー さま
            </h4>
            {/* <ul>
              <li>
                <Link to={"/"}>
                  <img src="/images/icon/home.svg" alt="icon"/>
                  ホーム
                </Link>
              </li>
            </ul> */}

            <h5>クーポン・お知らせ管理</h5>
            <ul>
              {/* <li><a href="http://localhost:8888/okageCRM/admin-merchant.php"><img src="/images/icon/shop.svg" />ショップ管理</a></li> */}
              <li>
                <Link to={"/coupon"}>
                  <img src="/images/icon/coupon.svg" alt="icon"/>
                  クーポン管理
                </Link>
              </li>
            
              <li>
                <Link to={"/info"}>
                  <img src="/images/icon/news.svg" alt="icon"/>
                  お知らせ管理
                </Link>
              </li>
              <li>
                <Link to={"/topic"}>
                  <img src="/images/icon/news.svg" alt="icon"/>
                  トピクス管理
                </Link>
              </li>
            </ul>

            <h5>会員管理</h5>

            <ul>
              <li>
                <Link to={"/user"}>
                  <img src="/images/icon/user.svg" alt="icon"/>
                  ユーザー管理
                </Link>
              </li>
              <li>
                <Link to={"/point"}>
                  <img src="/images/icon/point.svg" alt="icon"/>
                  ポイント管理
                </Link>
              </li>

            </ul>

            <h5>広告管理</h5>
            
            <ul>
              <li>
                <Link to={"/advertisement"}>
                  <img src="/images/icon/ad.svg" alt="icon"/>
                  広告管理
                </Link>
              </li>  
            </ul>
          </nav>
        </div>
        <div className="layoutRight">
          <main className="container">
            <section>
              <Outlet />
            </section>
            <footer className="copy">
              © 2024 smares Inc.
            </footer>
          </main>
        </div>
      </div>
    </>
  );
}
export default DefaultLayout;